export default __webpack_public_path__ + "static/media/union-group.592de217.svg";